<template>
  <div id="password-reset">
    <section class="hero is-success is-fullheight">
        <div class="hero-body">
          <div class="container has-text-centered">
            <div class="column is-4 is-offset-4">
              <h3 class="title has-text-grey">Reset password</h3>
              <p class="subtitle has-text-grey"></p>
              <div class="box">
                <figure class="avatar">
                  <img v-bind:src="'/static/img/logo.png'">
                </figure>
                <form @submit.prevent="passwordReset()">
                    <div class="title is-5 has-text-centered has-text-grey-dark"> Choose a new password </div>
                    <div class="field">                    
                        <bulma-input name="email" v-model="user.email" rules="required|email" placeholder='Your email'/>                    
                    </div>

                    <div class="field">                    
                        <bulma-input type="password" name="password" v-model="user.password" rules="required|min:6" placeholder='Your password'/>                    
                    </div>
                    
                    <div class="field">                    
                        <bulma-input type="password" name="password_confirmation" v-model="user.password_confirmation" rules="required" placeholder='Confirm your password'/>                    
                    </div>

                    <loading-submit v-bind:loading="loading" color="is-danger">Reset my password</loading-submit>
                    <!--<loading-button v-bind:loading="loading" color="is-danger" @click="passwordReset()">Reset my password</loading-button>-->
                  
                </form>
              </div>
              <p class="has-text-grey">
                <router-link to="/">
                    Login
                </router-link> &nbsp;·&nbsp;
                <router-link to="/forgot/password">
                    Forgot password?
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </section>    
  </div>  
</template>

<script>
import AuthRepo from './repos/AuthRepo'

export default {
  name: 'password-reset',
  components: {},
  data() {
        return {
            user: {token: this.$route.params.token}, 
            loading: false,
            repo: new AuthRepo(this.$auth)            
        }
  },
  created(){

  },
  methods: {
    passwordReset: function(){
        let self = this;
        this.$validator.validateAll().then((result) => {
	        if (result) {
                this.loading = true;
                this.repo.passwordReset(this.user).then(response => {
                    self.$toast.success(response.data.message);
                    self.$router.push('/');
                }).finally(function(){
                    self.loading = false;
                });       
            }
        });
    }
  }
  
}
</script>

<style lang="css" scoped>

html,body {
  font-family: 'Open Sans', serif;
  font-size: 14px;
  font-weight: 300;
}
.hero.is-success {
  background: #f5f5f5;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  height: 200px;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
  box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

html {
	font-size: 2.5em;
}
body {
	background-color: #fff;
	padding: 25px;
	text-align: center;
}

/* Wrapper */
.icon-button {
	background-color: white;
	border-radius: 3.6rem;
	cursor: pointer;
	display: inline-block;
	font-size: 1.8rem;
	height: 3.6rem;
	line-height: 3.6rem;
	margin: 0 5px;
	position: relative;
	text-align: center;
	-webkit-user-select: none;
	   -moz-user-select: none;
	    -ms-user-select: none;
	        user-select: none;
	width: 3.6rem;
}

/* Circle */
.icon-button span {
	border-radius: 0;
	display: block;
	height: 0;
	left: 50%;
	margin: 0;
	position: absolute;
	top: 50%;
	-webkit-transition: all 0.3s;
	   -moz-transition: all 0.3s;
	     -o-transition: all 0.3s;
	        transition: all 0.3s;
	width: 0;
}
.icon-button:hover span {
	width: 3.6rem;
	height: 3.6rem;
	border-radius: 3.6rem;
	margin: -1.8rem;
}

/* Icons */
.icon-button i {
	background: none;
	color: white;
	height: 3.6rem;
	left: 0;
	line-height: 3.6rem;
	position: absolute;
	top: 0;
	-webkit-transition: all 0.3s;
	   -moz-transition: all 0.3s;
	     -o-transition: all 0.3s;
	        transition: all 0.3s;
	width: 3.6rem;
	z-index: 10;
}

.twitter span {
	background-color: #4099ff;
}
.facebook span {
	background-color: #3B5998;
}
.google-plus span {
	background-color: #db5a3c;
}
.tumblr span {
	background-color: #34526f;
}
.instagram span {
	background-color: #517fa4;
}
.youtube span {
	background-color: #bb0000;
}
.pinterest span {
	background-color: #cb2027;
}

.icon-button .icon-twitter {
	color: #4099ff;
}
.icon-button .icon-facebook {
	color: #3B5998;
}
.icon-button .fa-tumblr {
	color: #34526f;
}
.icon-button .icon-google-plus {
	color: #db5a3c;
}
.icon-button .fa-instagram {
	color: #517fa4;
}
.icon-button .fa-youtube {
	color: #bb0000;
}
.icon-button .fa-pinterest {
	color: #cb2027;
}

.icon-button:hover .icon-twitter,
.icon-button:hover .icon-facebook,
.icon-button:hover .icon-google-plus,
.icon-button:hover .fa-tumblr,
.icon-button:hover .fa-instagram,
.icon-button:hover .fa-youtube,
.icon-button:hover .fa-pinterest {
	color: white;
}

@media all and (max-width: 680px) {
  .icon-button {
    border-radius: 1.6rem;
    font-size: 0.8rem;
    height: 1.6rem;
    line-height: 1.6rem;
    width: 1.6rem;
  }

  .icon-button:hover span {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 1.6rem;
    margin: -0.8rem;
  }

  /* Icons */
  .icon-button i {
	  height: 1.6rem;
	  line-height: 1.6rem;
	  width: 1.6rem;
  }
  body {

	  padding: 10px;
  }
  .pinterest {
   display: none; 
  }

}


</style>



// WEBPACK FOOTER //
// src/PasswordReset.vue